module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gdpr-consent"
  }, [_c('page-header', {
    attrs: {
      "title": "We're Updating How We Manage Data"
    }
  }), _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.$emit('seen')
      }
    }
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("We really appreciate you using our Teamwork.com collaboration\n products to power your business. Your success is important to us\n and we are constantly striving to improve our products performance\n and enable better productivity for all our customers.\n As part of this improvement we have made some important changes to\n how we protect data within Teamwork.com and we want to share these with you.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("We would like to share with you our updated "), _c('a', {
    attrs: {
      "href": "https://www.teamwork.com/privacy-statement",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Statement")]), _vm._v(". We are committed to the highest standards of data security\n & management and all our processes and systems have been\n updated to include the new provisions of GDPR.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("The new practices came into effect on "), _c('strong', [_vm._v("May 25, 2018")]), _vm._v(". If you have any questions about these changes please reach out to us at "), _c('a', {
    attrs: {
      "href": "mailto:privacy@teamwork.com"
    }
  }, [_vm._v("privacy@teamwork.com")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit",
      "autofocus": "autofocus"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("OK")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64aeb376","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/GDPRConsent/GDPRConsent.vue
// module id = 601
// module chunks = 1